import { TeamsService } from '@teams/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UpdateTeamMemberBody, UpdateTeamMemberPathParams } from '@core-http';

export class UpdateTeamMemberCommandHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  update(teamId: string, memberId: string, isAutoApproved: boolean): Observable<void> {
    const pathParams: UpdateTeamMemberPathParams = { teamId, userId: memberId };
    const requestBody: UpdateTeamMemberBody = { isAutoApproved };

    return this.teamsService.updateMember(pathParams, requestBody);
  }
}
